/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AddBookReaderResponsePayload model module.
 * @module model/AddBookReaderResponsePayload
 * @version v1.0.0
 */
class AddBookReaderResponsePayload {
    /**
     * Constructs a new <code>AddBookReaderResponsePayload</code>.
     * @alias module:model/AddBookReaderResponsePayload
     * @param comment {String} comment
     * @param rating {Number} rating
     */
    constructor(comment, rating) { 
        
        AddBookReaderResponsePayload.initialize(this, comment, rating);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, comment, rating) { 
        obj['comment'] = comment;
        obj['rating'] = rating;
    }

    /**
     * Constructs a <code>AddBookReaderResponsePayload</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AddBookReaderResponsePayload} obj Optional instance to populate.
     * @return {module:model/AddBookReaderResponsePayload} The populated <code>AddBookReaderResponsePayload</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AddBookReaderResponsePayload();

            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('rating')) {
                obj['rating'] = ApiClient.convertToType(data['rating'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * comment
 * @member {String} comment
 */
AddBookReaderResponsePayload.prototype['comment'] = undefined;

/**
 * rating
 * @member {Number} rating
 */
AddBookReaderResponsePayload.prototype['rating'] = undefined;






export default AddBookReaderResponsePayload;

